import { useState } from 'react';
import { RestAddress, RestAddressAttributes } from '../../../hooks/useAddress';
import { useCountry } from '../../CountrySelector';

export const useAddressState = (address?: RestAddress) => {
  const countryCode = useCountry().country.alpha2Code;

  return useState<RestAddressAttributes>(
    address?.attributes || {
      __typename: 'RestAddressAttributes',
      verified: null,
      source: 'moda',
      countryCode,
      firstName: '',
      lastName: '',
      phone: '',
      state: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      postalCode: ''
    }
  );
};
